import { render, staticRenderFns } from "./ProveedoresSelectComponent.vue?vue&type=template&id=515fd4d5&"
import script from "./ProveedoresSelectComponent.vue?vue&type=script&lang=js&"
export * from "./ProveedoresSelectComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports